import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  effect,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
import katex from 'katex';

import { OutcomeSvgComponent } from './outcome-svg.component';
import { ExperimentTrialResult } from './probability-experiment.model';

function renderLatex(latex: string): string {
  return katex.renderToString(latex, { throwOnError: false, output: 'html' });
}

@Component({
  selector: 'dojo-experiment-results-table',
  standalone: true,
  imports: [OutcomeSvgComponent],
  templateUrl: './experiment-results-table.component.html',
  styleUrl: './experiment-results-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'block' },
})
export class ExperimentResultsTableComponent {
  constructor() {
    effect(() => {
      const len = this.results().length;
      if (len === 0) {
        return;
      }

      const el = this.scrollContainer()?.nativeElement;
      if (!el) {
        return;
      }

      requestAnimationFrame(() => {
        el.scrollLeft = el.scrollWidth;
      });
    });
  }

  readonly results = input.required<ExperimentTrialResult[]>();
  readonly scrollContainer = viewChild<ElementRef<HTMLDivElement>>('scrollArea');

  readonly hashHtml = renderLatex('\\#');
  readonly outcomeHtml = renderLatex('\\text{Outcome}');
  readonly resultHtml = renderLatex('\\text{Result}');
}
